import React from "react";
// import ApexCharts from "react-apexcharts";

import ReactApexChart from "react-apexcharts";
import { GENERAL_REVIEWS, SPECIAL_REVIEWS } from "../../text-data";
import getChartDefultOption from "../../utils/getChartDefultOption";
import ChartDateOfWeek from "./ChartDateOfWeek";
import ChartLegend from "./ChartLegend";
const TotalReviewChart = ({ categories, series }) => {
  const options = getChartDefultOption({
    id: "chart--TotalReviewChart",
    categories,
    customColors: [
      'var(--color-chart-1)',
      'var(--color-chart-0)',
    ]
  });

  const legend = (function () {
    const sumArray = series.map((s) => s.data.reduce((a, b) => a + b, 0));

    const sum = sumArray.reduce((a, b) => a + b, 0);
    const percents = sumArray.map((s) => {
      if (!sum) return 0;
      return Math.round((s / sum) * 100);
    });
    const labels = [SPECIAL_REVIEWS, GENERAL_REVIEWS];

    return labels
      // .filter((label, i) => sumArray[i])
      .map((label, i) => {
        return [label, sumArray[i] + "개", `(${percents[i]}%)`];
      });
  })();

  return (
    <div>
      <div id="chart--TotalReviewChart">
        <ReactApexChart options={options} series={series} type="bar" />
      </div>
      {/* <div id="html-dist"></div> */}
      <ChartDateOfWeek />
      <ChartLegend ls={legend} />
    </div>
  );
};

export default TotalReviewChart;
